<template>
  <div id="app">
    <keep-alive>
       <transition>
          <router-view/>
       </transition>
    </keep-alive>
     <ScrollTop></ScrollTop>
    <!--底部开始-->
    <FooterView />
    <!--底部结束-->
  </div>
</template>

<script>
  import FooterView from '@/components/Footer.vue';
  import ScrollTop from '@/components/ScrollTop.vue';
   export default {
     name: "App",
     components:{
       FooterView,
       ScrollTop
     }
   }
</script>

<style lang="less">
@import './assets/style/common.less';
@import './assets/style/animate.less';
</style>
